import { Location } from "../Location";
import { BookingKitProfileLayout } from "../../booking-kits/components/booking-kit-profile/booking-kit-profile-layout";

import { bonlivaPipelineTheme } from "@bonliva-crm/ui";
import { ThemeProvider } from "@material-ui/core/styles";

interface Params {
  kitId: string;
}

export class KitProfileLocation extends Location<Params> {
  constructor(kitId: string) {
    super({ kitId });
  }

  render() {
    return (
      <ThemeProvider theme={bonlivaPipelineTheme}>
        <BookingKitProfileLayout kitId={this.params.kitId} />
      </ThemeProvider>
    );
  }

  toURI() {
    const { kitId } = this.params;
    return `/kits/${kitId || "new"} `;
  }
}
